var accordion = function () {

    // Selectors object
    var selectors = {
        expanderToggles: document.querySelectorAll(".expander-toggle")
    };
    
    let listeners = function(){

        selectors.expanderToggles.forEach(expanderToggle => {
            expanderToggle.addEventListener("click", function (e){
                e.preventDefault();
                e.target.closest('.accordion').classList.toggle('is--active');

                selectors.expanderToggles.forEach(trigger => {
                    if(e.target.closest('.accordion') !== trigger.closest('.accordion')){
                        trigger.closest('.accordion').classList.remove('is--active');
                    }
                })

            })
        });
    }
    
    listeners();
}();
